
class SubscriptionChange extends HTMLElement {
    constructor() {
        super();
        this.currentLineItem = this.getAttribute("index-item");
        this.planId = this.getAttribute("plan-id");
        this.productHandle = this.getAttribute("product-handle");
        this.productForm = document.getElementsByClassName('product-form');
        this.addEventListener('click',  this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    async connectedCallback() {
        console.log('i AM ADDED',this.productHandle);
        let sellingplan =   await fetch(`/products/${this.productHandle}.js`);
      console.log(sellingplan);
        let sellingresponse = await sellingplan.json();
        if(sellingresponse && sellingresponse.selling_plan_groups.length>0){
        }else{
            this.innerHTML = '';
        }
        // browser calls this method when the element is added to the document
        // (can be called many times if an element is repeatedly added/removed)
    }

    async onSubmitHandler() {

        let sellingplan =   await fetch(`/products/${this.productHandle}.js`);
        let sellingresponse = await sellingplan.json();
        if(sellingresponse){
            this.planId = sellingresponse.selling_plan_groups[0].selling_plans[0].id

            this.currentLineItem++;
const quantityInput = this.closest('.cart-item__quantity').querySelector('.quantity__input');
const quantityValue = Number(quantityInput.value);
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData();
            formData.append('line', this.currentLineItem);
          formData.append('quantity', quantityValue);
            if(this.planId=="0"){
                formData.append('selling_plan', '');
            }else{
                formData.append('selling_plan', this.planId);
            }
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
            config.body = formData;
let _trjh = this;
let sdfd = this.currentLineItem;
let Bundle_products;
               $.ajax({
        type: 'POST',
        url: '/cart.js',   
        dataType: 'json',
        success:function(cart_data){
cart_data.items.forEach(function (e,index) {
 console.log(sdfd,index)
if( sdfd == index + 1){
Bundle_products = e.properties.Bundle_products + '(30 Day Subscription) ';
  fetch(window.Shopify.routes.root+ 'cart/change.js', config)
            .then((response) => response.json())
            .then((response) => {
      
                _trjh.cart.renderContents(response);

                let page_main_class = document.querySelector('body').getAttribute("class");
                if (page_main_class.trim() == "gradient template-cart") {
                    location.reload();
                }
                 $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          line:_trjh.currentLineItem,
        'properties': { 
'Bundle_products': Bundle_products }
        },
        dataType: 'json',
        success:function(cha){

   }
      });
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
            });
}
})

   }
      });
          
        }
    }
};
customElements.define('subscription-change', SubscriptionChange)